import { gql } from '@apollo/client';
import { client } from '..';
import {
  TranslateArticleQuery,
  TranslateArticleQueryVariables,
} from '../../__generated__/queries-web';

const TRANSLATE_ARTICLE_QUERY = gql`
  query TranslateArticle(
    $where: ArticleUniqueFilterInput!
    $lang: NonEmptyTrimmedString!
  ) {
    translateArticle(where: $where, lang: $lang) {
      title
      body
      lead
    }
  }
`;

export const translateArticleQuery = async (id: string, lang: string) => {
  return await client.query<
    TranslateArticleQuery,
    TranslateArticleQueryVariables
  >({
    fetchPolicy: 'no-cache',
    query: TRANSLATE_ARTICLE_QUERY,
    variables: { where: { id }, lang },
  });
};
